export const getElementByCssPath = ({ path }: { path: string }): Element | null =>
    document.querySelector(path);
